var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.59375C3.68596 0.59375 0.59375 3.68596 0.59375 7.5C0.59375 11.314 3.68596 14.4062 7.5 14.4062C11.314 14.4062 14.4062 11.314 14.4062 7.5C14.4062 3.68596 11.314 0.59375 7.5 0.59375ZM8.6724 10.312C8.72381 10.3608 8.76492 10.4195 8.79331 10.4844C8.8217 10.5494 8.83679 10.6194 8.8377 10.6903C8.83861 10.7612 8.82531 10.8316 8.7986 10.8973C8.77188 10.963 8.73228 11.0226 8.68214 11.0728C8.632 11.1229 8.57233 11.1625 8.50665 11.1892C8.44096 11.2159 8.37059 11.2292 8.29969 11.2283C8.22879 11.2274 8.15878 11.2123 8.0938 11.1839C8.02883 11.1555 7.97019 11.1144 7.92135 11.063L4.73385 7.87553C4.63429 7.77591 4.57837 7.64084 4.57837 7.5C4.57837 7.35916 4.63429 7.22409 4.73385 7.12447L7.92135 3.93697C8.02179 3.84155 8.15553 3.78914 8.29406 3.79091C8.43259 3.79268 8.56494 3.8485 8.66291 3.94647C8.76087 4.04443 8.81669 4.17679 8.81846 4.31532C8.82024 4.45385 8.76783 4.58759 8.6724 4.68803L5.86076 7.5L8.6724 10.312Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorLeft);
export default __webpack_public_path__ + "static/media/vector-left.a6c9cd08678ff67442499fbc2ba8d687.svg";
export { ForwardRef as ReactComponent };